// extracted by mini-css-extract-plugin
export default {"wrapper":"Privacy_wrapper__UCBvN","inner":"Privacy_inner__EAyQR","title":"Privacy_title__E00No","section":"Privacy_section__hpwHH"};